import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
/* SQUIDDI-seo - 2026-10-17 · Niente <React.StrictMode>: in sviluppo monta ogni
   componente due volte e react-helmet-async registra la sua istanza solo al
   primo `render()`. La finta smontata la toglieva dall'elenco e i tag <head>
   della pagina (description, canonical, og:*) restavano cancellati. Senza
   StrictMode i tag sono corretti sia in anteprima sia nel sito pubblicato
   (in produzione StrictMode non raddoppiava comunque nulla). */
root.render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </HelmetProvider>,
);
